export default {
    headerHeight: '60px',
};
